import { DeleteDisplayGroupInvite, DeleteDisplayGroupInviteVariables } from './__generated__/DeleteDisplayGroupInvite'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

export const DELETE_DISPLAY_GROUP_INVITE_MUTATION = gql`
  mutation DeleteDisplayGroupInvite($input: DeleteDisplayGroupInviteInputV2!) {
    deleteDisplayGroupInviteV2(input: $input) {
      ... on DisplayGroupInviteV2 {
        id
        email
        role
      }
      ... on DisplayGroupInviteErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteDisplayGroupInvite = () => {
  return useMutation<DeleteDisplayGroupInvite, DeleteDisplayGroupInviteVariables>(DELETE_DISPLAY_GROUP_INVITE_MUTATION)
}
